import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}

// COIPLAY_COI0023_AMAZON_GALLERY_RUNTIME_20260614_START
(function () {
  const handle = "/products/meow-bark-bookmark-craft-kit";
  if (!location.pathname.includes(handle)) return;

  const replacements = [
    ["COI0023_MeowBark_family", "https://cdn.shopify.com/s/files/1/0722/6094/4059/files/coi0023_amazon_listing_01_01_main_815_swwx1ml.jpg?v=1781488166"],
    ["COI0023_MeowBark_tin", "https://cdn.shopify.com/s/files/1/0722/6094/4059/files/coi0023_amazon_listing_02_02_pt01_91kc_dzqodl.jpg?v=1781488168"],
    ["coi0023_gallery_04_coi0023_listing_square_01_695", "https://cdn.shopify.com/s/files/1/0722/6094/4059/files/coi0023_amazon_listing_03_03_pt02_714wjxaoldl.jpg?v=1781488169"],
    ["coi0023_gallery_05_coi0023_listing_square_02_696", "https://cdn.shopify.com/s/files/1/0722/6094/4059/files/coi0023_amazon_listing_04_04_pt03_8193qjps7cl.jpg?v=1781488171"],
    ["coi0023_gallery_06_coi0023_listing_square_03_697", "https://cdn.shopify.com/s/files/1/0722/6094/4059/files/coi0023_amazon_listing_05_05_pt04_81zwztsr_jl.jpg?v=1781488173"],
    ["coi0023_gallery_07_coi0023_listing_square_04_698", "https://cdn.shopify.com/s/files/1/0722/6094/4059/files/coi0023_amazon_listing_06_06_pt05_8157zdkb9il.jpg?v=1781488175"]
  ];

  function cdnSized(url, width) {
    if (!width) return url;
    return url.replace(/\.jpg\?v=/, "_" + width + "x.jpg?v=");
  }

  function replaceUrl(value) {
    if (!value) return value;
    for (const [needle, target] of replacements) {
      if (value.includes(needle)) return target;
    }
    return value;
  }

  function replaceSrcset(value, target) {
    if (!value || !target) return value;
    return value
      .split(",")
      .map((part) => {
        const widthMatch = part.match(/\s(\d+)w/);
        const width = widthMatch ? widthMatch[1] : "";
        const descriptor = width ? " " + width + "w" : "";
        return " " + cdnSized(target, width) + descriptor;
      })
      .join(",");
  }

  function swapMedia() {
    document.querySelectorAll("img").forEach((img) => {
      const current = img.currentSrc || img.getAttribute("src") || img.getAttribute("srcset") || "";
      const target = replaceUrl(current);
      if (target === current) return;
      img.setAttribute("src", target);
      if (img.getAttribute("srcset")) img.setAttribute("srcset", replaceSrcset(img.getAttribute("srcset"), target));
      img.setAttribute("data-coiplay-amazon-gallery", "20260614");
    });

    document.querySelectorAll("source[srcset]").forEach((source) => {
      const srcset = source.getAttribute("srcset") || "";
      const target = replaceUrl(srcset);
      if (target !== srcset) {
        source.setAttribute("srcset", replaceSrcset(srcset, target));
      }
    });

    document.querySelectorAll("a[href]").forEach((anchor) => {
      const href = anchor.getAttribute("href") || "";
      const target = replaceUrl(href);
      if (target !== href) anchor.setAttribute("href", target);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", swapMedia, { once: true });
  } else {
    swapMedia();
  }
  setTimeout(swapMedia, 600);
  setTimeout(swapMedia, 1800);
})();
// COIPLAY_COI0023_AMAZON_GALLERY_RUNTIME_20260614_END
